<div [class.page]="!embedded">
  <div class="title-btn-container">
    <div class="title">{{ 'store.redemptionPoints.title' | translate }}</div>

    <div class="btns-container">
      <button *ngIf="(featureFlagService.isFeatureEnabled$('store_redemption_points') | async)" (click)="onCreateRpoint(rpointTemplate)">
        <img src="assets/images/add-btn.png" alt="">
        {{ 'store.redemptionPoints.create' | translate }}
      </button>
    </div>

  </div>

  <div class="redemptions-filters-container">
    <div class="inputs-container">
      <app-select [selectedItem]="params.cityId" [options]="cities" (changeSelect)="changeCity($event)"></app-select>
      <div class="search-container">
        <img src="assets/images/search.svg">
        <input [(ngModel)]="params.search" (keyup.enter)="doSearchByEnter($event);" (keyup)="doSearchByKeyUp($event);"
          [placeholder]="'store.redemptionPoints.searchPlaceholder' | translate" type="text">
      </div>
      <app-select [selectedItem]="params.onlyActive" [options]="statusList"
        (changeSelect)="changeStatus($event)"></app-select>
    </div>


    <div class="totals-stats">
      <div class="value">{{totalPoints}}</div>
      <div class="label">{{ 'store.redemptionPoints.count' | translate }}</div>
    </div>

  </div>
  <div class="table-wrapper">
    <table class="table AgentsTable">
      <thead>
        <tr>
          <th>{{ 'store.redemptionPoints.table.createdDate' | translate }}</th>
          <th>{{ 'store.redemptionPoints.table.username' | translate }}</th>
          <th>{{ 'store.redemptionPoints.table.password' | translate }}</th>
          <th>{{ 'common.city' | translate }}</th>
          <th>{{ 'common.branch' | translate }}</th>
          <th>{{ 'store.redemptionPoints.table.paymentCode' | translate }}</th>
          <th>{{ 'store.redemptionPoints.table.balance' | translate }}</th>
          <th>{{ 'common.status' | translate }}</th>
          <th *ngIf="(featureFlagService.isFeatureEnabled$('store_redemption_points') | async)"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataList; let i = index">
          <td ><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y'}}</span></td>
          <td>{{item.userName}}</td>
          <td>{{item.password}}</td>
          <td>{{item?.city?.name}}</td>
          <td>{{item.branchName}}</td>
          <td>
            <span class="rp-payment-code" *ngIf="item.paymentCode; else noCode">{{item.paymentCode}}</span>
            <ng-template #noCode><span class="rp-payment-code rp-payment-code--empty">{{ 'store.redemptionPoints.noPaymentCode' | translate }}</span></ng-template>
          </td>
          <td ><span class="ltr-text">{{item.balance != null ? (item.balance | currency:'ILS':'code') : '-'}}</span></td>
          <td>
            <div style="margin-right: auto; margin-left: auto" [class]="item.status">{{ statusLabel(item.status) }} </div>
          </td>

          <td class="dots-container" *ngIf="(featureFlagService.isFeatureEnabled$('store_redemption_points') | async)">
            <button [placement]="'left'" [outsideClick]="true" #pop="bs-popover" [popover]="popTemplate">
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </button>

            <ng-template #popTemplate>
              <div style="cursor: pointer;border-bottom: 0.5px solid #dee3e7;padding: 10px;"
                (click)="onEditRpoint(item, rpointTemplate, pop)">
                {{ 'store.redemptionPoints.editAction' | translate }}
              </div>
              <div style="cursor: pointer; padding: 10px; color: red;"
                (click)="onRemoveRpoint(item.id, deleterpointTemplate, pop)"> {{ 'common.remove' | translate }}
              </div>
            </ng-template>
          </td>
        </tr>
      </tbody>

    </table>
    <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.redemptionPoints.empty' | translate }}</div>

  </div>
  <div class="table-footer">
    <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
      (nextClicked)="nextClick($event)"></app-pagination>
    <app-export-csv *ngIf="(featureFlagService.isFeatureEnabled$('store_redemption_points') | async)" [disabled]="!dataList?.length" path="web/redemption-points/export"
      [params]="exportparams"></app-export-csv>
  </div>
  <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
</div>


<ng-template #rpointTemplate>
  <div *ngIf="!finishCU">

    <div class="modal-header">
      <img src="assets/images/x-modal.svg" (click)="modalRef?.hide()" alt="">
      <h5 *ngIf="!isEditMode">{{ 'store.redemptionPoints.createTitle' | translate }}</h5>
      <h5 *ngIf="isEditMode">{{ 'store.redemptionPoints.editTitle' | translate }}</h5>
    </div>
    <div class="modal-body">

      <div class="two-input-container">
        <div class="label-container">{{ 'store.redemptionPoints.table.username' | translate }}</div>
        <div class="label-container">{{ 'store.redemptionPoints.table.password' | translate }}</div>
        <div class="input-container">
          <input [(ngModel)]="rPoint.userName" type="text" [placeholder]="'store.redemptionPoints.table.username' | translate"
            (keyup)="userNameSearchByKeyUp($event);">
          <div *ngIf="isSubmitted && !rPoint.userName?.toString()?.trim()" class="error">{{ 'store.redemptionPoints.usernameRequired' | translate }}</div>
          <div *ngIf="!isUserNameValid" class="error">{{ 'store.redemptionPoints.usernameTaken' | translate }}</div>
        </div>
        <div class="input-container">
          <input [(ngModel)]="rPoint.password" type="text" [placeholder]="'store.redemptionPoints.table.password' | translate"
            (keyup)="passwordSearchByKeyUp($event);">
          <div *ngIf="isSubmitted && !rPoint.password?.toString()?.trim()" class="error">{{ 'store.redemptionPoints.passwordRequired' | translate }}</div>
          <div *ngIf="!isPasswordValid" class="error">{{ 'store.redemptionPoints.passwordLength' | translate }}</div>
        </div>

        <div class="label-container">{{ 'common.city' | translate }}</div>
        <div class="label-container">{{ 'common.branch' | translate }}</div>
        <div class="input-container">
          <app-select [selectedItem]="rPoint.cityId" [options]="citiesWithoutAll"
            (changeSelect)="changeCreatedCity($event)"></app-select>
          <div *ngIf="isSubmitted && !rPoint.cityId?.toString()?.trim()" class="error">{{ 'store.redemptionPoints.cityRequired' | translate }}</div>
        </div>
        <div class="input-container">
          <input [(ngModel)]="rPoint.branchName" type="text" [placeholder]="'store.redemptionPoints.branchArea' | translate">
          <div *ngIf="isSubmitted && !rPoint.branchName?.toString()?.trim()" class="error">{{ 'store.redemptionPoints.branchRequired' | translate }}</div>
        </div>
      </div>

      <div class="checkBox-text" style="margin-top: 8px;">
        <label class="custom-checkbox" style="top: 4px;">
          <input type="checkbox" [(ngModel)]="rPoint.isActive">
          <span class="checkmark"></span>
        </label>
        <span> {{ 'store.redemptionPoints.activate' | translate }}</span>
      </div>
      <button *ngIf="!isEditMode" class="create-btn" (click)="CreateRP()">{{ 'common.create' | translate }}</button>
      <button *ngIf="isEditMode" class="create-btn" (click)="EditRP()">{{ 'common.saveChanges' | translate }}</button>
    </div>
  </div>

  <div class="redeemed-container" *ngIf="finishCU">
    <img src="assets/images/success_icon.png">
    <h5 *ngIf="!isEditMode">{{ 'store.redemptionPoints.created' | translate }}</h5>
    <h5 *ngIf="isEditMode">{{ 'store.redemptionPoints.updated' | translate }}</h5>
    <div *ngIf="!isEditMode" style="font-size: 13px;
  font-weight: 400;
  font-style: normal;
  color: #262626;
  text-align: center;">
      {{ 'store.redemptionPoints.createdHint' | translate }}
    </div>
    <div *ngIf="isEditMode" style="font-size: 13px;
  font-weight: 400;
  font-style: normal;
  color: #262626;
  text-align: center;">
      {{ 'store.redemptionPoints.updatedHint' | translate }}
    </div>
    <button class="done-btn" (click)="onDone()">{{ 'common.done' | translate }}</button>
    <a *ngIf="!isEditMode" class="CreateAnother-text" (click)="CreateAnother()"> {{ 'store.redemptionPoints.createAnother' | translate }} </a>
  </div>
</ng-template>

<ng-template #deleterpointTemplate>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="delete-confirmation">
          <div class="confirmation-box">
            <p>{{ 'common.confirmDelete' | translate }}</p>
            <button style="background-color: #4caf50; color: white;" (click)="confirmDelete()">{{ 'common.yes' | translate }}</button>
            <button style="background-color: #e53935; color: white;" (click)="cancelDelete()">{{ 'common.no' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
